const header = document.querySelector('.header');
const syncHeader = () => document.documentElement.style.setProperty('--header-height', `${header?.getBoundingClientRect().height || 80}px`);
syncHeader();
window.addEventListener('resize', syncHeader, { passive: true });
function filterProducts(filter, maker) {
  const grid = document.querySelector('#product-grid');
  if (!grid) return;
  let visible = 0;
  grid.querySelectorAll('.product-card').forEach(card => {
    const makerMatches = !maker || card.dataset.maker.toLowerCase() === maker.toLowerCase();
    const categoryMatches = filter === 'All' || (filter === 'Gifts' ? Number(card.dataset.price) < 5000 : filter === 'Crossbody' ? card.dataset.crossbody === 'true' : card.dataset.category === filter);
    card.hidden = !makerMatches || !categoryMatches;
    if (!card.hidden) visible++;
  });
  grid.classList.toggle('filtered', filter !== 'All' || Boolean(maker));
  const empty = document.querySelector('.filter-empty');
  if (empty) empty.hidden = visible > 0;
  document.querySelectorAll('[data-filter]').forEach(button => {
    const active = !maker && button.dataset.filter === filter;
    button.classList.toggle('active', active);
    button.setAttribute('aria-pressed', String(active));
  });
}
document.addEventListener('click', event => {
  const button = event.target.closest('button');
  if (!button) return;
  if (button.classList.contains('menu-button')) {
    const open = button.getAttribute('aria-expanded') !== 'true';
    button.setAttribute('aria-expanded', String(open));
    document.querySelector('.mobile-nav').hidden = !open;
  }
  if (button.dataset.image) {
    const image = document.querySelector('#gallery-main');
    image.src = button.dataset.image;
    image.removeAttribute('srcset');
    image.alt = button.dataset.alt;
    image.style.cssText = button.dataset.imageStyle || '';
    document.querySelector('#full-image-link').href = button.dataset.image;
    document.querySelectorAll('[data-image]').forEach(item => {
      item.classList.toggle('active', item === button);
      item.setAttribute('aria-pressed', String(item === button));
    });
  }
  if (button.dataset.filter || button.dataset.maker) {
    filterProducts(button.dataset.filter || 'All', button.dataset.maker);
    if (button.dataset.maker) document.querySelector('#collection').scrollIntoView({ behavior: 'smooth' });
  }
});
document.querySelectorAll('.mobile-nav a').forEach(link => link.addEventListener('click', () => {
  document.querySelector('.mobile-nav').hidden = true;
  document.querySelector('.menu-button').setAttribute('aria-expanded', 'false');
}));
document.querySelector('#objects-variant')?.addEventListener('change', event => {
  const selected = event.target.selectedOptions[0];
  const button = document.querySelector('#objects-add');
  document.querySelector('#variant-price').textContent = selected.dataset.price;
  button.disabled = selected.dataset.available !== 'true' || button.dataset.enable !== 'true';
  button.textContent = selected.dataset.available === 'true' ? button.dataset.addLabel : button.dataset.soldLabel;
  const url = new URL(location.href);
  url.searchParams.set('variant', selected.value);
  history.replaceState({}, '', url);
  if (selected.dataset.variantImage) {
    const image = document.querySelector('#gallery-main');
    image.src = selected.dataset.variantImage;
    image.removeAttribute('srcset');
    image.style.cssText = '';
    document.querySelector('#full-image-link').href = selected.dataset.variantImage;
    document.querySelectorAll('[data-image]').forEach(item => {
      const active = item.dataset.image === selected.dataset.variantImage;
      item.classList.toggle('active', active);
      item.setAttribute('aria-pressed', String(active));
    });
  }
});
